import { Component, ElementRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core'
import { TranslationService } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { CookieService } from 'ngx-cookie-service'
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop'
import { combineLatest, of, Subscription } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { EbModalComponent } from '../../../../components/modal/eb-modal.component'
import { EbQuickOrderService } from '../../services/eb-quick-order.service'

@Component({
    selector: 'eb-quick-order',
    templateUrl: './eb-quick-order.component.html',
    styleUrls: ['./eb-quick-order.component.scss'],
    standalone: false
})
export class EbQuickOrderComponent implements OnDestroy {
  @ViewChild('modal') modal: EbModalComponent
  loaded$ = of(true)
  quickOrderSubscription: Subscription

  constructor(
    protected quickOrderService: EbQuickOrderService,
    protected cookieService: CookieService,
    protected modalService: LaunchDialogService,
    protected ebElement: ElementRef,
    protected vcr: ViewContainerRef,
    protected translationService: TranslationService
  ) {}
  onFileDropChange(droppedFile: NgxFileDropEntry[]) {
    if (droppedFile[0].fileEntry.isFile) {
      const fileEntry = droppedFile[0].fileEntry as FileSystemFileEntry
      fileEntry.file((file: File) => {
        combineLatest([
          this.translationService.translate('csv.waiting.description'),
          this.translationService.translate('csv.waiting.title')
        ])
          .pipe(
            take(1),
            map(([description, title]) => {
              const dialog = this.modalService.openDialog(
                'FILE_DROP_CHANGE',
                this.ebElement,
                this.vcr,
                {
                  loaded$: this.loaded$,
                  description,
                  title,
                  withoutClose: true
                }
              )
              dialog?.pipe(take(1))?.subscribe()
            })
          )
          .subscribe()
        this.quickOrderSubscription = this.quickOrderService.uploadCsvFile(file).subscribe()
      })
    }
  }

  downloadTemplate() {
    this.quickOrderService.downloadCsvTemplate()
  }

  ngOnDestroy(): void {
    if (this.quickOrderSubscription) {
      this.quickOrderSubscription.unsubscribe()
    }
  }
}
